export default __webpack_public_path__ + "static/media/D750_Lanciano.5583456b.jpg";